const headeBarSearch = () => {
  const inputHead = document.querySelector("#search-input-head");
  const input = document.querySelector("#search-input-head input");
  const inputSearch = document.getElementById("Search");

  const isSearchPage = window.location.pathname === "/search";

  if (isSearchPage && inputSearch) {
    inputSearch.focus();
    inputSearch.click();
    inputSearch.setSelectionRange(
      inputSearch.value.length,
      inputSearch.value.length,
    );
  }

  if (input) {
    const searchButton = document.querySelector("#search-input-head a");
    input.addEventListener("input", () => {
      searchButton.href = `/search?q=${encodeURIComponent(input.value)}`;
    });

    inputHead.addEventListener("mouseover", () => {
      if (isSearchPage) return;
      input.focus();
      input.classList.add("active");
    });

    inputHead.addEventListener("mousemove", () => {
      if (isSearchPage && inputSearch) return;
      input.focus();
      //  input.classList.add("active");
    });

    inputHead.addEventListener("mouseenter", () => {
      if (isSearchPage) return;

      input.focus();
      input.classList.add("active");
    });

    document.addEventListener("click", (e) => {
      const toElement = e.relatedTarget;

      if (toElement && inputHead.contains(toElement)) return;

      input.classList.remove("active");
      input.value = "";
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        window.location.href = `/search?q=${encodeURIComponent(input.value)}`;
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  headeBarSearch();
  document.querySelector(".search-content .search__input")?.focus();
});
